export default "__VITE_ASSET__DliVU44U__"